var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C4.72386 0 4.5 0.223858 4.5 0.5V1C4.5 1.27614 4.72386 1.5 5 1.5C5.27614 1.5 5.5 1.27614 5.5 1H10C10 1.27614 10.2239 1.5 10.5 1.5C10.7761 1.5 11 1.27614 11 1V0.5C11 0.223858 10.7761 0 10.5 0H5ZM1.5 2C1.22386 2 1 2.22386 1 2.5C1 2.77614 1.22386 3 1.5 3H14.5C14.7761 3 15 2.77614 15 2.5C15 2.22386 14.7761 2 14.5 2H1.5ZM6 5.5C6 5.22386 5.77614 5 5.5 5C5.22386 5 5 5.22386 5 5.5V11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5V5.5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V11.5C10 11.7761 10.2239 12 10.5 12C10.7761 12 11 11.7761 11 11.5V5.5ZM8 5.5C8.27614 5.5 8.5 5.72386 8.5 6V11C8.5 11.2761 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.2761 7.5 11V6C7.5 5.72386 7.72386 5.5 8 5.5ZM3 3.5C3.27614 3.5 3.5 3.72386 3.5 4V13H12.5V4C12.5 3.72386 12.7239 3.5 13 3.5C13.2761 3.5 13.5 3.72386 13.5 4V13.5C13.5 13.7761 13.2761 14 13 14H3C2.72386 14 2.5 13.7761 2.5 13.5V4C2.5 3.72386 2.72386 3.5 3 3.5Z",
    fill: "#E71111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c667a3cc701df5a0face8150833a0624.svg";
export { ForwardRef as ReactComponent };